import React, { useEffect } from "react";

const ConditionsGarantie: React.FC = () => {
  const title = "Conditions de garantie | MON COPIEUR";
  const description = "Conditions de garantie MON COPIEUR / CPI TRADE: modalités, exclusions, retours et extension Garantie+.";
  
  useEffect(() => {
    document.title = title;
    let metaTag = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.name = "description";
      document.head.appendChild(metaTag);
    }
    metaTag.content = description;
  }, []);
  
  return (
    <>
      <header className="border-b border-border bg-secondary/40">
        <div className="container mx-auto px-4 py-10">
          <h1 className="text-3xl font-semibold">Conditions de garantie</h1>
        </div>
      </header>

      <article className="prose prose-neutral max-w-none container mx-auto px-4 py-8">
        <section>
          <h2>1. Modalités de garantie</h2>
          <p>
            Tous les produits vendus par MON COPIEUR / CPI TRADE bénéficient d'une garantie constructeur
            selon les termes et conditions spécifiés par le fabricant. La durée de garantie varie selon
            le type de produit et est indiquée sur la fiche produit.
          </p>
        </section>

        <section>
          <h2>2. Conditions d'application</h2>
          <ul>
            <li>La garantie s'applique uniquement aux défauts de fabrication</li>
            <li>Le produit doit être utilisé dans des conditions normales d'utilisation</li>
            <li>La facture d'achat doit être présentée comme justificatif</li>
            <li>La garantie prend effet à compter de la date de livraison</li>
          </ul>
        </section>

        <section>
          <h2>3. Exclusions de garantie</h2>
          <p>Sont exclus de la garantie :</p>
          <ul>
            <li>Les dommages résultant d'une mauvaise utilisation</li>
            <li>L'usure normale des pièces</li>
            <li>Les dommages causés par un accident ou une négligence</li>
            <li>Les modifications ou réparations effectuées par des tiers non agréés</li>
            <li>Les consommables (cartouches, toners, papier)</li>
          </ul>
        </section>

        <section>
          <h2>4. Procédure de retour</h2>
          <p>
            En cas de problème couvert par la garantie, contactez notre service client au
            +212 522 401708 ou par email à contact@moncopieur.ma. Nous vous fournirons les
            instructions pour le retour du produit.
          </p>
        </section>

        <section>
          <h2>5. Extension de garantie "Garantie+"</h2>
          <p>
            Nous proposons une extension de garantie optionnelle "Garantie+" qui prolonge la
            couverture au-delà de la garantie constructeur standard. Cette extension doit être
            souscrite au moment de l'achat et fait l'objet de conditions particulières.
          </p>
        </section>

        <section>
          <h2>6. Service après-vente</h2>
          <p>
            Notre équipe technique qualifiée assure la maintenance et la réparation de tous les
            équipements vendus. Nous disposons d'un stock de pièces détachées pour assurer un
            service rapide et efficace.
          </p>
        </section>
      </article>
    </>
  );
};

export default ConditionsGarantie;